import { IApplicationState } from '../../types/redux';
import { selectSeoH1 } from '../seo';

export const selectPageTitle = (state: IApplicationState) => {
  const seoH1 = selectSeoH1(state);

  if (seoH1) {
    return seoH1;
  }

  const name = state.buildersProjects.data.location?.namePrepositional;

  let title = 'Проекты домов от строительных компаний';

  if (name) {
    title += ` ${name}`;
  }

  return title;
};
